import { createSelector } from 'reselect'
import { selectIsInboxBootstrapped } from 'selectors/app/base'
import { selectIsInInbox } from 'selectors/location'
import storage from 'util/storage'
import selectIntegrationCredentialsByProvider from './selectIntegrationCredentialsByProvider'

export default createSelector(
  selectIsInboxBootstrapped,
  selectIsInInbox,
  selectIntegrationCredentialsByProvider,
  (isInboxBootstrapped, isInInbox, integrationCredentialsByProvider) => {
    if (!storage.get('showShopifyV2') || !isInInbox || !isInboxBootstrapped)
      return false

    return (
      !!integrationCredentialsByProvider.SHOPIFY &&
      !integrationCredentialsByProvider.SHOPIFY_V2
    )
  }
)
